import {
  CreateOrderReq,
  CreateOrderResp,
  DeleteOrderReq,
  DeleteOrderResp,
  GetAvailableProductsReq,
  GetAvailableProductsResp,
  ListDiagnocoinLedgerReq,
  ListDiagnocoinLedgerResp,
  ProcessOrderReq,
  ProcessOrderResp,
  SetAccountBillingInformationReq,
  SetAccountBillingInformationResp,
  SetAccountBillingZonesReq,
  SetAccountBillingZonesResp,
  SetTransactionNumberToOrderReq,
  SetTransactionNumberToOrderResp,
  Test_ExpireSubscriptionAfterReq,
  Test_ExpireSubscriptionAfterResp,
  SetAccountWithoutStripeInvoicesReq,
  SetAccountWithoutStripeInvoicesResp,
} from 'protocol/api/billing_new/svc_billing_new_pb';

import api, { Billing } from '@/shared/api/api';
import { SliceName } from '@/shared/config';
import { createThunkGenerator } from '@/shared/lib';

type BillingRequests = keyof typeof Billing['methods'];

const generateBillingThunk = createThunkGenerator<BillingRequests>(
  SliceName.billing,
);

export const toggleAccountStripe = generateBillingThunk<
  SetAccountWithoutStripeInvoicesReq,
  SetAccountWithoutStripeInvoicesResp
>(
  'setAccountWithoutStripeInvoices',
  api.billing.setAccountWithoutStripeInvoices,
);

export const setAccountBillingInformation = generateBillingThunk<
  SetAccountBillingInformationReq,
  SetAccountBillingInformationResp
>('setAccountBillingInformation', api.billing.setAccountBillingInformation);

export const processOrder = generateBillingThunk<
  ProcessOrderReq,
  ProcessOrderResp
>('processOrder', api.billing.processOrder);

export const setTransactionNumberToOrder = generateBillingThunk<
  SetTransactionNumberToOrderReq,
  SetTransactionNumberToOrderResp
>('setTransactionNumberToOrder', api.billing.setTransactionNumberToOrder);

export const getAvailableProducts = generateBillingThunk<
  GetAvailableProductsReq,
  GetAvailableProductsResp
>('getAvailableProducts', api.billing.getAvailableProducts);

export const createOrder = generateBillingThunk<
  CreateOrderReq,
  CreateOrderResp
>('createOrder', api.billing.createOrder);

export const deleteOrder = generateBillingThunk<
  DeleteOrderReq,
  DeleteOrderResp
>('deleteOrder', api.billing.deleteOrder);

export const setAccountBillingZone = generateBillingThunk<
  SetAccountBillingZonesReq,
  SetAccountBillingZonesResp
>('setAccountBillingZones', api.billing.setAccountBillingZones);

export const setExpireSubscriptionAfter = generateBillingThunk<
  Test_ExpireSubscriptionAfterReq,
  Test_ExpireSubscriptionAfterResp
>('test_ExpireSubscriptionAfter', api.billing.test_ExpireSubscriptionAfter);

export const listDiagnocoinLedger = generateBillingThunk<
  ListDiagnocoinLedgerReq,
  ListDiagnocoinLedgerResp
>('listDiagnocoinLedger', api.billing.listDiagnocoinLedger);
